<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="employeeService"
    [idKey]="'employeeId'"
/>